import { useMemo } from 'react';
import { ServiceConfig } from '@common-fe/common-fe';

import { Option } from '@/common/types';

import {
  ALL_OTHERS_NOT_SPECIFIED,
  ALL_OTHERS_NOT_SPECIFIED_LABEL,
} from '../AddServicePaymentModal.constants';

export default (serviceTypeOptions: Option[], serviceConfigs?: ServiceConfig[]) => {
  const usedServiceIds = useMemo(() => {
    if (!serviceConfigs) return [];

    return serviceConfigs.flatMap((config) => config.services?.map((service) => service.id) || []);
  }, [serviceConfigs]);

  const unusedServiceIds = useMemo(() => {
    return serviceTypeOptions
      .filter((option) => option.key && !usedServiceIds.includes(String(option.key)))
      .map((option) => String(option.key));
  }, [serviceTypeOptions, usedServiceIds]);

  const enhancedServiceTypeOptions = useMemo(() => {
    if (unusedServiceIds.length === 0) {
      return serviceTypeOptions;
    }

    const allOthersOption: Option = {
      key: ALL_OTHERS_NOT_SPECIFIED,
      value: ALL_OTHERS_NOT_SPECIFIED,
      name: ALL_OTHERS_NOT_SPECIFIED_LABEL,
      title: ALL_OTHERS_NOT_SPECIFIED_LABEL,
      divide: true,
    };

    return [allOthersOption, ...serviceTypeOptions];
  }, [serviceTypeOptions, unusedServiceIds]);

  return { enhancedServiceTypeOptions, unusedServiceIds };
};
